import { arrayContainsValues } from '@shared/core/types/common';

const googleSupportedCards: google.payments.api.allowedCardNetworks = ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA', 'ELECTRON', 'MAESTRO', 'ELO', 'ELO_DEBIT'];

export const googleSupportedCardsType = arrayContainsValues(...googleSupportedCards);
